import { MarkerDisplay, MarkerDisplaySize } from 'types/location.js';
import { IMarker } from 'types/markerCore/marker-core-type.js';
import { predicateMarkerV1 } from 'utilities/isType.js';
import { convertL1MarkerZoomToL2, convertL3MarkerZoomToL2 } from './zoom-convert.js';
import { MarkerZoomTuple } from './zoom-v1.js';
import { ZoomLevelsMap } from './zoom-v3.js';

export const MARKER_ZOOM_DEFAULT = { default: MarkerDisplaySize.Large };

/** Should marker display or not V1 only  */
export const getMarkerVersionZoomDisplay = (marker?: IMarker) => {
  if (predicateMarkerV1(marker)) {
    return marker.zoomDisplay;
  }
  return undefined;
};

/** Normalises marker zoom levels from different formats into one coherent one */
export const normaliseMarkerZoom = ({
  markers,
  markerDisplay,
  zoomThemes,
}: {
  markers: IMarker[];
  markerDisplay?: MarkerDisplay;
  zoomThemes?: ZoomLevelsMap;
}): MarkerZoomTuple[] => {
  const markerZoomTuple: MarkerZoomTuple[] = markers.map((m) => {
    if (predicateMarkerV1(m)) {
      if (markerDisplay?.zoom) {
        const val: MarkerZoomTuple = [m, markerDisplay.zoom];
        return val;
      }
      if (markerDisplay?.levels) {
        const val: MarkerZoomTuple = [m, convertL1MarkerZoomToL2(markerDisplay.levels)];
        return val;
      }
      const val: MarkerZoomTuple = [m, MARKER_ZOOM_DEFAULT];
      return val;
    }
    if (m.zoom) {
      /** Has marker specific zoom */
      const val: MarkerZoomTuple = [m, convertL3MarkerZoomToL2(m.zoom)];
      return val;
    }
    if (m.tags?.length && zoomThemes) {
      const firstMatchingKey = Object.keys(zoomThemes).find((val) => m.tags?.includes(val));
      if (firstMatchingKey) {
        const val: MarkerZoomTuple = [m, convertL3MarkerZoomToL2(zoomThemes[firstMatchingKey])];
        return val;
      }
    }
    const val: MarkerZoomTuple = [m, MARKER_ZOOM_DEFAULT];
    return val;
  });
  return markerZoomTuple;
};
